import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { LoginService } from 'src/app/services/login.service';
import { sha256 } from 'js-sha256'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login-candidate',
  templateUrl: './login-candidate.component.html',
  styleUrls: ['./login-candidate.component.scss']
})
export class LoginCandidateComponent implements OnInit {


  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');

  constructor(private router: Router,
    private _login: LoginService,
    private fb: FormBuilder) {

    this.options = fb.group({
      username: ['', Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)],
      password: ['', Validators.minLength(3)]
    });

  }

  alertmsg = false;
  spinner = false;

  ngOnInit(): void {
  }

  login() {
    this._login.loginCandidate({
      username: this.options.value.username,
      password: (this.options.value.password)
    }).subscribe(res => {
      sessionStorage.setItem('token', res.token)
      this.router.navigate(['/instructions/'])
      this.spinner = false;
    }, err => {
      this.alertmsg = true
      this.spinner = false;
    })
  }

  admin(){
    this.router.navigate(['/login'])
  }

}
